import type { CustomerFragment } from '#graphql-operations'
import { activeCustomer as $activeCustomer } from '@layers/common/app/services/auth'
import { defineStore } from 'pinia'

export const useActiveCustomerStore = defineStore('activeCustomer', () => {
  const activeOrderStore = useActiveOrderStore()
  const { $gtm } = useNuxtApp()

  const activeCustomer = ref<CustomerFragment | null>(null)

  const fetchActiveCustomer = async () => {
    const customer = await $activeCustomer()
    activeCustomer.value = customer || null
    return customer
  }

  const currentCustomer = computed(() => activeCustomer.value || activeOrderStore.activeOrder.data?.customer)

  let previousUserId: string | number | null = null

  watch(currentCustomer, (customer) => {
    const newUserId = customer?.id || null

    if (newUserId !== previousUserId) {
      previousUserId = newUserId
      $gtm?.push?.({ user_id: newUserId })
    }
  }, { immediate: true })

  return {
    activeCustomer: readonly(activeCustomer),
    currentCustomer,
    fetchActiveCustomer,
  }
})
